import selectScroll from '@/utils/select-scroll.js';

export default function setupDirectives(Vue) {
    // 滚动加载指令
    Vue.directive('select-scroll', selectScroll);
}
